export default "__VITE_ASSET__CEW5oqg9__"